<template>
   <div :id="id" class="echarts"></div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import * as echarts from 'echarts';
export default {
    name: 'echartsList',
    props:{
        name:{
            type:String,
            default:() => null
        },
        xdata:{
            type:Object,
            default:() => null
        },
        ydata:{
            type:Object,
            default:() => null
        },
        series:{
            type:Object,
            default:() => null
        },
        imgId:{
            type:String,
            default:() => null
        },
    },
    setup(props) {
        const data = reactive({
            id:props.name,
            xdata:props.xdata,
            ydata:props.ydata,
            series:props.series,
            imgId:props.imgId
        })
        onBeforeMount(() => {})
        onMounted(() => {
            const myChart = echarts.init(document.getElementById(data.id))
            myChart.setOption({
                title:{
                    text:data.series.title ? data.series.title : '',
                    left:40,
                    top:0
                },
                xAxis: {
                    type: 'category',
                    name:data.xdata.name,
                    data: data.xdata.data,
                    axisTick: {
                        alignWithLabel: true,
                        inside:true,
                        length:0,
                    },
                    axisLabel: {
                        //  X 坐标轴标签相关设置
                        interval: 0,
                        // rotate: data.xdata.rotate ? data.xdata.rotate : 0
                        padding:[4,4,4,4]
                    }
                },
                yAxis: {
                    type: 'value',
                    min:0,
                    name:data.ydata.name,
                    boundaryGap:['20%', '20%'],
                    axisLine: {
                        show: true, // Y轴
                    },
                    axisLabel:{
                        show:true,
                        formatter: data.ydata.type == 1 ? '{value}%' : '{value}'
                    },
                },
                series: [
                    {
                        data: data.series.data,
                        center: ['50%', '50%'],
                        barWidth: 25, // 柱子宽度
                        label:{
                            name:'A',
                            show:true,
                            position: 'top',
                            align:'center',
                            formatter: function (params) {
                                if(params.data.type == 1){
                                    return '{a|}'+'\n'+'\n'+'|'+'\n'+'\n'+params.data.value
                                }
                            },
                            rich:{
                                a:{
                                    backgroundColor: {
                                        image: '/api/fileSystem/file/download?fileId='+data.imgId
                                    },
                                    height: 33,
                                }
                            },
                        },
                        type: 'bar'
                    },
                ]
            },true)
        })
        return {
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.echarts{
    width: 100%;
    height: 100%;
}
</style>